import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRecipe } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import type { Recipe } from "../types";

export function useUpdateRecipe() {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({
      recipeId,
      data,
    }: {
      recipeId: string;
      data: Partial<Recipe>;
    }) => {
      const token = await getToken();
      if (!token) throw new Error("Not authenticated");
      return updateRecipe(recipeId, data, token);
    },
    onSuccess: (updated) => {
      queryClient.invalidateQueries({ queryKey: ["recipes"] });
      queryClient.invalidateQueries({ queryKey: ["recipe", updated.slug] });
    },
  });
}
